<template>
  <NewsBanner />
  <NewsTop />
  <NewsList />
</template>

<script lang="ts" type="text/tsx">
import NewsBanner from '@template/page/news/_component/newsBanner.vue';
import NewsTop from '@template/page/news/_component/newsTop.vue';
import NewsList from '@template/page/news/_component/newsList.vue';

export default {
  name: 'news',
  components: {
    NewsBanner,
    NewsTop,
    NewsList
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/news/';
</style>